/* ScidLogoComponent template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { ScidLogoComponent } from './cwc-scid-logo';

/**
 * Definition of  parameters that the template needs to work.
 */
interface ScidLogoTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: ScidLogoComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const ScidLogoTemplate: FunctionalComponent<ScidLogoTemplateProps> = ({ controller }) => (
  <Host>
    {controller.link != '' ? (
      <a href={controller.link}>
        <img src={controller.currentLogoPath} alt="Logo" />
      </a>
    ) : (
      <img src={controller.currentLogoPath} alt="Logo" />
    )}
  </Host>
);

export default ScidLogoTemplate;
